import { render, staticRenderFns } from "./SideBarDownload.vue?vue&type=template&id=4b083187&scoped=true"
import script from "./SideBarDownload.vue?vue&type=script&lang=js"
export * from "./SideBarDownload.vue?vue&type=script&lang=js"
import style0 from "./SideBarDownload.vue?vue&type=style&index=0&id=4b083187&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b083187",
  null
  
)

export default component.exports